import { useState, useEffect } from "react";
import { useReport } from "contexts/ReportContext";
import { IOccurrence } from "interfaces/Occurrence";
import { getReportPdf } from "services/ReportServices";
import { StepModalTemplate } from "templates/StepModalTemplate";
import { Tab } from "../../TabHeader";
import { EstablishmentReportModal } from "../EstablishmentReportModal";

import * as S from "../StepRegister/StepRegisterOccurrence/styles";
import { VehicleReportModal } from "../VehicleReportModal";
import { ClientTab } from "./Tabs/clientTab";
import { CommentsTab } from "./Tabs/commentsTab";
import { PaymentTab } from "./Tabs/PaymentTab";
import { PolicemanTab } from "./Tabs/policemanTab";
import { AttachmentsTab } from "./Tabs/AttachmentsTab";

type Props = {
  opened: boolean;
  setOpened: (value: boolean) => void;
  occurrenceData: IOccurrence;
  hasAttachmentTab?: boolean;
};

function StepReportModal({
  opened,
  setOpened,
  occurrenceData,
  hasAttachmentTab,
}: Props) {
  const { searching, report, sending, retrieveReport } = useReport();

  const tabs = [
    { index: 0, text: "Visão Geral" },
    { index: 1, text: "Pronta-resposta" },
    { index: 2, text: "Cliente" },
    { index: 3, text: "Comentários" },
    { index: 4, text: "Pagamento" },
  ];
  const tabsWithAttachment = [
    { index: 0, text: "Visão Geral" },
    { index: 1, text: "Pronta-resposta" },
    { index: 2, text: "Cliente" },
    { index: 3, text: "Comentários" },
    { index: 4, text: "Anexo" },
    { index: 5, text: "Pagamento" },
  ];

  const [tab, setTab] = useState<Tab>(tabs[0]);
  const [invalidTabs, setInvalidTabs] = useState<Tab[]>([]);
  const [patrimonialType, setPatrimonialType] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // useEffect(() => {
  //   if (occurrenceData) {
  //     setInvalidTabs([]);
  //     setPatrimonialType(occurrenceData.patrimonialType);

  //     return;
  //   }
  // }, [occurrenceData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    retrieveReport(occurrenceData);
  }, [occurrenceData]);

  function onTabClick(_tab: Tab) {
    setTab(_tab);
  }
  async function handleSubmit() {
    setIsLoading(true);
    report &&
      getReportPdf(report.id)
        .then(async (res) => {
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
  }
  return (
    <StepModalTemplate
      deactivatedTabs={[]}
      title="Ocorrência"
      isOneTabModal
      opened={opened}
      setOpened={setOpened}
      buttonText={
        isLoading || searching
          ? "Carregando..."
          : report?.occurrence?.status !== "concluido"
          ? "Não concluída"
          : "Exportar Relatório"
      }
      sending={
        isLoading ||
        searching ||
        sending ||
        report?.occurrence?.status !== "concluido"
      }
      handleSubmit={handleSubmit}
      tabs={hasAttachmentTab ? tabsWithAttachment : tabs}
      selectedTab={tab}
      invalidTabs={invalidTabs}
      setSelectedTab={onTabClick}
      disableButton={report ? false : true}
    >
      <S.Container>
        {searching ? (
          <S.LoadingWrapper>
            <span>Buscando dados da ocorrência...</span>
          </S.LoadingWrapper>
        ) : report ? (
          <div>
            {tab.index === 0 && patrimonialType === 1 && (
              <EstablishmentReportModal />
            )}

            {tab.index === 0 && patrimonialType === 2 && <VehicleReportModal />}

            {tab.index === 1 && <PolicemanTab />}
            {tab.index === 2 && <ClientTab />}
            {tab.index === 3 && <CommentsTab />}
            {hasAttachmentTab && tab.index === 4 && <AttachmentsTab />}
            {hasAttachmentTab && tab.index === 5 && <PaymentTab />}
            {!hasAttachmentTab && tab.index === 4 && <PaymentTab />}
          </div>
        ) : (
          <S.LoadingWrapper>
            <span>Ocorrência ainda sem relatório...</span>
          </S.LoadingWrapper>
        )}
      </S.Container>
    </StepModalTemplate>
  );
}

export { StepReportModal };
